import { deleteTime } from "../../../../CastingBotFirebase";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabTable from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabTable";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import PrettifyDate from "../../../../_shoru_shared_library/functions/PrettifyDate";

function ViewTimesTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;

  const header = ['Date', 'Start Time', 'End Time', 'Location', 'Slot Length']
  const body = _parseToTable(castingData.times);

  const handleDelete = (i) => {
    deleteTime(castingData.times[i], userData.active_organisation_id, castingData.uid, setCastingData);
  }

  if(body.length > 0) 
  {
    return (
      <SubTabParent passData={props}>
        <SubTabTable header={header} body={body} deleteFunction={handleDelete} />
      </SubTabParent>
    )
  }
  else 
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Times' 
        description='Add audition times to see them here' 
      />
    )
  }

}

export default ViewTimesTab;



const _parseToTable = (times) => {
  let timeArray = times.map((time) => {
    return [...[PrettifyDate(time.date, true), time.start, time.end, time.location, (time.slot_length + ' minutes')]];
  })
  return timeArray;
}